"use strict";

// ---------------------------------------------------
// Dependencies

var FieldRule = require('bunsen/validation/deprecated/rules/FieldRule');

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Module Definition and Instance Properties

/**
 * @class RegexRule
 * @extends FieldRule
 */
var RegexRule = module.exports = FieldRule.extend({
    noMatch: false,
    initialize: function (options) {
        options = options || {};
        RegexRule.__super__.initialize.call(this, options);
        this.regex = options.regex || this.regex;
    },
    outputSchema: function () {
        return {
            validator: this.regex,
            noMatch: this.noMatch
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/validation/deprecated/rules/RegexRule.js
// module id = 85
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56